module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propTitle prop-header hide\"><span class=\"prop-label\">Button Details</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Save</label> \r\n            <div class=\"col-md-10 nopadding\">\r\n                <input type=\"text\" name=\"buttonLabelSave\" value=\"")
    ; __append(escapeFn( buttonLabelSave ))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection nopadding-r\">\r\n            <label class=\"prop-sublabel label-35\">Clear</label> \r\n            <div class=\"col-md-10 nopadding\">\r\n                <input type=\"text\" name=\"buttonLabelClear\" value=\"")
    ; __append(escapeFn( buttonLabelClear ))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n    </div>\r\n")
  }
  return __output;

}